/**
 * Helpers for practice enrolled care programs (RPM / CCM).
 */

const normalizeProgramKey = (value) => String(value || '').trim().toLowerCase();

export function extractPracticeProgramKeys(summaryPayload) {
  const data = summaryPayload?.data?.data ?? summaryPayload?.data ?? summaryPayload;
  const enrolled = data?.enrolled_programs;
  if (!Array.isArray(enrolled)) return [];
  return enrolled
    .map((p) =>
      normalizeProgramKey(typeof p === 'string' ? p : p?.short_name || p?.id || p?.label || '')
    )
    .filter(Boolean);
}

export function getPracticeProgramFlags(summaryPayloadOrKeys) {
  const keys = Array.isArray(summaryPayloadOrKeys)
    ? summaryPayloadOrKeys.map(normalizeProgramKey)
    : extractPracticeProgramKeys(summaryPayloadOrKeys);
  return {
    hasRpm: keys.some((k) => k === 'rpm'),
    hasCcm: keys.some((k) => k === 'ccm'),
    hasPcm: keys.some((k) => k === 'pcm'),
  };
}
